var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-box",class:_vm.float},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"bar1"}),_c('div',{staticClass:"bar2"}),_c('div',{staticClass:"bar3"}),_c('div',{staticClass:"bar4"})])
}]

export { render, staticRenderFns }